import { useEffect, useState, useRef } from "react";
import { ChangeAlertCallbackType, ChangeLoaderCallbackType } from "../../../Root";
import { closelightbox } from "../../../../util/Functions";
import { AfbService } from "../../../../services/AfbService";

export const useInvestmentAdmin = (open: boolean, changeAlert: ChangeAlertCallbackType, changeLoader: ChangeLoaderCallbackType) => {
    const afbService = useRef<AfbService>();
    
    const [selectedForm, setSelectedForm] = useState<string | null>(null);
    const [isValidForm, setIsValidForm] = useState<boolean>(true);
    const [zPos, setZPos] = useState(45);
    const [error, setError] = useState(null);
    const [form, setForm] = useState(null);
    const [searchForm, setSearchForm] = useState(null);
    const units = [
        { key: "day", label: "Diario" },
        { key: "month", label: "Mensual" },
        { key: "year", label: "Anual" },
    ];
	let agent = localStorage.session ? JSON.parse(localStorage.session) : {};
    
    const onSelectForm = (value) => {
        onFormReset();

        setSelectedForm(value);
        value === "create" ?
        setForm({
            customer_uuid: "",
            metadata: {
                unit_of_duration: "",
                duration: 0,
                rate_of_return: 0,
                amount: 0,
            },
            agent: agent["email"]
        }) :
        setForm({
            uuid: "",
            metadata: {
                tx_return_funds: "",
                tx_earnings: "",
                actual_earnings: 0
            },
            agent: agent["email"]
        });
    };

    const onHandleSearch = (e) => {
        setSearchForm({customer_uuid: e["target"]["value"].trim()});
    };

    const onHandleChange = (key1, key2, e) => {
        let f = form || {};
        let er = error;
        let value = Number(e["target"]["value"]) ? Number(e["target"]["value"]) : e["target"]["value"];

        if (key2 && key1) {
            let val = value;
            f[key1] ? (f[key1][key2] = val) : (f[key1] = { [key2]: val });
        } else if (key1) {
            f[key1] = value;
        } else if (!key1 && key2) {
            f[key2] = value;
        }

        if(key2 === "amount"){
            value < 100000 ? er = "El monto mínimo de pago inicial es de $100,000.00" : er = null;
        }
        
        validateForm(f, er);
        setError(JSON.parse(JSON.stringify(er)));
        setForm(JSON.parse(JSON.stringify(f)));
    };


    const validateForm = (f, err) => {
        const allFieldsFilled = 
        Object.values(f['metadata']).every((field) => {
            return typeof field === "number" ? field > 0 : String(field).trim() !== '';
        }) && 
        Object.values(f).filter(value => typeof value === 'string').every(value => String(value).trim() !== '');
        setIsValidForm(!allFieldsFilled);
        err && setIsValidForm(true);
    };

    const onSearch = async () => {
        changeLoader(true);
        setZPos(-1);

        let f = form;
        
        const response = await afbService.current.afbInvestmentGetActive(searchForm);
        if (response?.data?.response === "OK") {
			f["uuid"] = response.data.content["uuid"];
        } else {
			changeAlert(true, 'error', `Error al realizar acción: ${response["message"] || response["data"]["message"]}`);
        }
        changeLoader(false);
        setZPos(45);
    };
    
    const onConfirm = async () => {
        changeLoader(true);
        setZPos(-1);

        const response = await afbService.current[selectedForm === "create" ? "afbInvestmentCreate" : "afbInvestmentComplete"](form);
        if (response?.data?.response === "OK") {
			changeAlert(true, 'success', "El registro se actualizó con éxito.");
            changeLoader(false);
            closelightbox();
        } else {
			changeAlert(true, 'error', `Error al realizar acción: ${response["message"] || response["data"]["message"]}`);
            changeLoader(false);
            setZPos(45);
        }
    };
    
    const onClose = () => {
        onFormReset();
        closelightbox();
    };

    const onFormReset = () => {
        setForm(null);
        setError(null);
        setSelectedForm(null);
        setIsValidForm(true);
        setSearchForm(null);
    };

    useEffect(() => {
        afbService.current = new AfbService(changeAlert);

        if (!open) {
            onFormReset();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    return {
        zPos,
        form,
        error,
        units,
        searchForm,
        isValidForm,
        selectedForm,
        onSelectForm,
        onHandleChange,
        onHandleSearch,
        onSearch,
        onConfirm,
        onClose,
    };
};
